import { FETCH_SENSORS,FETCH_SENSOR , FETCH_COMPONENTS , FETCH_SUBSYSTEM, FETCH_LISTSENSORS } from '../types/sensor';
import Axios from 'axios';
const { getHost } = require('../../ip');
let yourConfig = { headers: { Authorization: "Bearer " + localStorage.getItem("authToken") } }

/* export and distribute the action in the container component : FETCH_SENSORS,FETCH_SENSOR , FETCH_COMPONENTS , FETCH_SUBSYSTEM, FETCH_LISTSENSORS */


export const fetchSensors = (group, component,startdate, enddate) => {
  return async function (dispatch, getState) {
    function onSuccess(response) {
      dispatch({ type: FETCH_SENSORS, payload: response.data });
    }

    function onError(error) {
    }
    try {
     //const response = await  Axios.get(`${getHost()}/api/sensorweather/weather/${group}/${component}/${startdate}/${enddate}`,yourConfig)
   const response = await  Axios.get(`${getHost()}/api/sensorweather/weather/${group}/${component}/${startdate}/${enddate}`,yourConfig)
      onSuccess(response.data);
    }
    catch (err) {
      onError(err);
    }
  };
};

export const fetchSensor = (userSensor, startdate, enddate) => {
  return async function (dispatch, getState) {

    function onSuccess(response) {
   /*  // console.log('success WHILE fetching Sensors', response); */
      dispatch(fetchSensors());
      dispatch({ type: FETCH_SENSOR, payload: response});
    }
    function onError(err) {
    }
    try {
     const response = await  Axios.get(`${getHost()}/api/sensorlistsens/sensorli3/${userSensor}/${startdate}/${enddate}`,yourConfig)
      onSuccess(response.data.value);
    }
    catch (err) {
      onError(err);
    }
  };
};

export const fetchSubsystems = (startdate, enddate) => {
  return async function (dispatch, getState) {

    function onSuccess(response) {
/*    //  console.log('success WHILE fetch Subsystems', response); */
      dispatch({ type: FETCH_SUBSYSTEM, payload: response.data });
    }
    function onError(err) {
    }
    try {
     const response = await  Axios.get(`${getHost()}/api/sensors/lisgro/${startdate}/${enddate}/`)
//console.log("response", response.data.data)
     onSuccess(response.data);
    }
    catch (err) {
      onError(err);
    }
  };
};

export const fetchComponents = (component,startdate, enddate) => {
  return async function (dispatch, getState) {

    function onSuccess(response) {
   /* //  console.log('success WHILE fetching Sensors', response); */
      dispatch({ type: FETCH_COMPONENTS, payload: response.data });
    }
    function onError(err) {
    }
    try {
    //  console.log('5555555555555555555555555555555', component,startdate, enddate)
     const response = await  Axios.get(`${getHost()}/api/sensors/subligro/${component}/${startdate}/${enddate}/`)
      onSuccess(response.data);
    }
    catch (err) {
      onError(err);
    }
  };
};

export const fetchSensorsBycomp = (subsystem, component, startdate, enddate) => {
  return async function (dispatch, getState) {

    function onSuccess(response) {
 /*    // console.log('success WHILE fetch sensors by components', response); */
      dispatch({ type: FETCH_LISTSENSORS, payload: response.data });
    }
    function onError(err) {
    }
    try {
     const response = await  Axios.get(`${getHost()}/api/sensorlistsens/listsens/${subsystem}/${component}/${startdate}/${enddate}`)
      onSuccess(response.data);
    }
    catch (err) {
      onError(err);
    }
  };
};
